"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassTheTrashOptions = void 0;
/** PassTheTrashOptions.tsx
 *
 * Game Options for PassTheTrash.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.PassTheTrashOptions = {
    versions: [
        {
            title: "7 Cards",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            default: true,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault, defaultOptions_1.winnerLowOnly, defaultOptions_1.winnerHighLowSplit],
    options: [defaultOptions_1.optionNoneDefault],
    wildcards: [defaultOptions_1.wildcardNoneDefault, defaultOptions_1.wildcardDeuces, defaultOptions_1.wildcardOneEyedJacks],
};
//# sourceMappingURL=PassTheTrashOptions.js.map